import type { Slab } from "building-types/foundations/foundationTypes";
import type { GeneratedFoundationSuperSystem } from "building-types/foundations/foundationTypes";
import type { Table } from "common/data/table";
import type { RWTable } from "common/data/table";
import { makeSlab } from "../elements/foundation/foundationSuperSystem";

export function resolvedFoundationSuperSystemAdjacencies(
  foundationSuperSystems: Table<GeneratedFoundationSuperSystem>,
): RWTable<GeneratedFoundationSuperSystem> {
  const resolvedFoundationSystem: RWTable<GeneratedFoundationSuperSystem> = {};

  for (const foundationId in foundationSuperSystems) {
    const foundation = foundationSuperSystems[foundationId];

    const foundationSlabs: Slab[] = [];
    const otherSlabsByClass: Slab[][] = [];

    for (const otherFoundationId in foundationSuperSystems) {
      const other = foundationSuperSystems[otherFoundationId];
      if (otherFoundationId !== foundationId && foundation.levelId === other.levelId) {
        for (const slab of other.superSystem.slabs) {
          if (!otherSlabsByClass[slab.roomClass]) {
            otherSlabsByClass[slab.roomClass] = [];
          }
          otherSlabsByClass[slab.roomClass].push(slab);
        }
      }
    }

    for (const slab of foundation.superSystem.slabs) {
      const slabEdgeSubtractions: Slab[] = [];
      for (let i = 0; i < slab.roomClass; i++) {
        if (otherSlabsByClass[i]) {
          slabEdgeSubtractions.push(...otherSlabsByClass[i]);
        }
      }

      if (slabEdgeSubtractions.length) {
        const {
          halfEdges,
          size,
          exteriorProfile,
          planProfile,
          roomClass,
          planProfileHalfEdges,
          exteriorProfileHalfEdges,
          hashParams,
        } = slab;

        foundationSlabs.push(
          makeSlab({
            hashParams,
            halfEdges,
            roomClass,
            size,
            exteriorProfile,
            planProfile,
            prioritySlabs: slabEdgeSubtractions,
            planProfileHalfEdges,
            exteriorProfileHalfEdges,
            levelId: foundation.levelId,
          }),
        );
      } else {
        foundationSlabs.push(slab);
      }
    }

    resolvedFoundationSystem[foundationId] = {
      ...foundation,
      superSystem: {
        ...foundation.superSystem,
        slabs: foundationSlabs,
      },
    };
  }

  return resolvedFoundationSystem;
}
